/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import axios from 'axios'
import { clearSentryUser } from '@/config/sentry'
axios.defaults.headers.common['Accept'] = 'application/json'

export default {
    login({ state, rootState, commit, dispatch }, user) {
        return new Promise((resolve, reject) => {
            try {
                axios
                    .post(`${process.env.VUE_APP_BACKEND_URL}/api/tokens`, user)
                    .then((response) => {
                        if (
                            !response.data.token ||
                            response.data.token.length <= 0
                        ) {
                            reject('Token not found')
                        }

                        var token = response.data.token.split('|')[1]

                        commit('setToken', token)
                        commit('setUser', response.data.user)
                        commit('setCompany', response.data.user.company)

                        window.localStorage.setItem('token', token)

                        dispatch('initialiseStore', null, { root: true })

                        dispatch('fetchMe').then(() => {
                            resolve()
                        }).catch(() => {
                            resolve()
                        })
                    })
                    .catch((error) => {
                        reject(error)
                    })
            } catch (error) {
                reject(error)
            }
        })
    },
    forgotPassword({ rootState, state }, user) {
        return new Promise((resolve, reject) => {
            axios
                .post(
                    `${process.env.VUE_APP_BACKEND_URL}/api/forgot-password`,
                    user
                )
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    resetPassword({ rootState, state }, user) {
        return new Promise((resolve, reject) => {
            axios
                .post(
                    `${process.env.VUE_APP_BACKEND_URL}/api/reset-password`,
                    user
                )
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    logout({ commit }) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${process.env.VUE_APP_BACKEND_URL}/api/logout`)
                .then(() => {
                    localStorage.clear()
                    clearSentryUser()
                    commit('admin/leaveImpersonation', null, { root: true })
                    resolve()
                })
                .catch((error) => {
                    // Always wipe local state even if the API call fails
                    localStorage.clear()
                    clearSentryUser()
                    commit('admin/leaveImpersonation', null, { root: true })
                    reject(error)
                })
        })
    },

    fetchMe({ rootState, commit }) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${process.env.VUE_APP_BACKEND_URL}/api/users/me`)
                .then(({ data }) => {
                    commit('setRole', data.role)
                    commit('setPermissions', data.permissions)
                    resolve(data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    searchUser({ rootState }, search) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${rootState.baseURL}/users/find`, { params: { search } })
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },

    updateLocale({ rootState, state }, locale) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${rootState.baseURL}/users/${state.user.id}/locale`, {
                    locale
                })
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }
}
